import processes from "./processes";
import users from "./users";
import trackings from "./trackings";
import roleIds from "./rolesIds";
import enterprises from "./enterprises";
import nfses from "./nfses";
import notifications from "./notifications";
import expenses from "./expenses";
import nfsesServicos from "./nfsesServicos";
import receivables from "./receivables";
import projectedReceivables from "./projectedReceivables";
import vwFechProcessosTotais from "./vwFechProcessosTotais";
import processComments from "./processComments";
import processStageLogs from "./processStageLogs";
import vwFechProcDespesas from "./vwFechProcDespesas";
import vwFechProcRazaoItems from "./vwFechProcRazaoItems";
import fin129 from "./fin129";
window.strapiToken =
  "01ec26bb5ea553cfddc8c13103e7e6b3ca1ee263ea32c0f67733662929f913e4d8ea92ee7eea63a11fdf5daf7516a83819db9043e6132b08da57266c7698f8774e235b2273947ede3ff2c20780cce2db7b3f1a3eb54e50f79a8fa20f80a8f70ce24726e71679250a95e42662365275fe2377a2cb30dd5258f406b93d540c213a";

var strapiApi = {
  processes,
  users,
  trackings,
  roleIds,
  enterprises,
  nfses,
  notifications,
  expenses,
  nfsesServicos,
  receivables,
  projectedReceivables,
  vwFechProcessosTotais,
  processComments,
  processStageLogs,
  vwFechProcDespesas,
  fin129,
  vwFechProcRazaoItems,
};

export default strapiApi;
